// import Logo_BYZ from './co-byz.png'
// import Logo_BYZ from './CO-BYZV3.png'
// import Logo_BYZ from './CO-BYZ.png'
import Logo_BYZ from './CO-BYZ-BOLD.png'


import NodataFound from './No-data-amico.png'
import ground from './ground.jpg'
import coupon from './coupon.png'



const Images = {
    Logo_BYZ,
    NodataFound,
    ground,
        coupon,

}

export default Images;